module.exports = __webpack_public_path__ + "assets/img/heart-white.f5304997.svg";